module.exports = __webpack_public_path__ + "media/images/sports_icons/012-fishing-ef6d4912629cd32d3ff74551ca0e9794.png";